import React from "react";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";

class ImgMediaCard extends React.Component {
	handleImageClick(value) {
		this.props.onClick(this.props.imageId);
	}

	render() {
		return (
			<Card
				onClick={this.handleImageClick.bind(this)}
			>
				<CardActionArea>
					<CardMedia
						style={{
							filter: this.props.projectData?"brightness(50%)":null,
						}}
						component="img"
						// height="200"
						// width="300"
						image={this.props.imageSrc}
						alt="Impact Project"
					/>
					{this.props.projectData?(
						<h1
						style={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							color: "#ffffff",
							textAlign: "center",
							fontSize: "25px",
							fontWeight: "bolder",
						}}
					>
						{this.props.projectData.name}
					</h1>
					):null}

				</CardActionArea>
			</Card>
		);
	}
}

export default ImgMediaCard;
